module.exports = "/static/media/sort_icon.503a4912.svg";